import type { ModalProps } from '@mantine/core';
import { Modal as MantineModal, ScrollArea } from '@mantine/core';
import React from 'react';

import styles from './Modal.module.css';

export const LBModalLayout = React.forwardRef<
  React.ElementRef<typeof MantineModal>,
  ModalProps
>(({ children, ...props }, ref) => (
  <MantineModal
    {...props}
    ref={ref}
    centered
    lockScroll
    classNames={styles}
    radius={16}
    scrollAreaComponent={ScrollArea.Autosize}
    shadow='heavy'
    size='xs'
    overlayProps={{
      color: '#5F6163',
      backgroundOpacity: 0.22,
      blur: 16
    }}
  >
    {children}
  </MantineModal>
));
